module.exports = __webpack_public_path__ + "static/media/rodeo-logistics-powered-by-mobile-logo.a38362e9.svg";